import { string, bool } from 'prop-types';

export default {
    id: string,
    slug: string,
    name: string,
    featured: bool,
    summary: string
};
